import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {filter} from 'rxjs';

@Component({
  selector: 'app-auth-layout.component',
  imports: [
    RouterOutlet
  ],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
})
export class AuthLayoutComponent implements OnInit {

  useAuthLayout = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    // 🔥 handle FIRST load + navigation
    this.updateLayout();

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => this.updateLayout());
  }

  private updateLayout(): void {
    const child = this.route.firstChild;
    this.useAuthLayout = !child?.snapshot.data['noAuthLayout'];
  }
}
